export const DEFAULT_PER_GROUP = 15;
export const DEFAULT_PER_GROUP_SAVED_FROM_STORE = 10;
export const DEFAULT_PER_PAGE = 15;
export const DEFAULT_PER_PAGE_COUPONS = 20;
export const DEFAULT_PER_PAGE_MY_ITEMS_SEARCH = 20;
export const DEFAULT_PER_PAGE_GLOBAL_ITEMS_SEARCH = 10;
export const DEFAULT_TIMESTAMP_LANDING_TOTAL = 86400000;
export const SEED = (Math.random() * 2 - 1).toFixed(5);
export const TAGS_PER_PAGE = 20;
